import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import * as L from 'leaflet'
import 'leaflet.heat'

type Point = { latitude: number; longitude: number; intensity?: number; count?: number }

export default function HeatLayer({ points, radius = 25, blur = 15, maxZoom = 18 }: { points: Point[]; radius?: number; blur?: number; maxZoom?: number }) {
  const map = useMap()

  useEffect(() => {
    if (points.length === 0) {
      return
    }

    const mapSize = map.getSize()
    if (mapSize.x <= 0 || mapSize.y <= 0) {
      return
    }

    const heatPoints = points.map((p) => [p.latitude, p.longitude, p.intensity ?? (p.count ?? 1)])
    const layer = (L as any).heatLayer(heatPoints, {
      radius,
      blur,
      maxZoom,
      gradient: {
        0.25: '#facc15',
        0.55: '#f97316',
        0.85: '#ef4444',
      },
    })
    layer.addTo(map)

    return () => {
      layer.remove()
    }
  }, [map, points, radius, blur, maxZoom])

  return null
}
